/**
 * Normalize unassigned-trip reasons for analytics chart grouping.
 * Merges variants that differ only by driver fractions or mileage.
 * Combined planner pipe-separated reasons are split into per-phase keys.
 */

function normalizeReasonSegment(segment) {
  let s = String(segment || '').trim();
  if (!s) return '';

  // Primary reason only when planners join multiple with ";"
  s = s.split(';')[0].trim();

  // Combined planner: "Failed P1-P4: ..." -> "P1-P4: ..."
  s = s.replace(/^Failed\s+(P\d+(?:-P\d+)?)\s*:/i, '$1:');

  // All mileage variants -> single label
  s = s.replace(/Base deadhead\s*\([^)]*mi[^)]*\)/gi, 'Base deadhead');

  // Strip "(14/32 drivers)" / "(14/32 driver)" — may repeat
  s = s.replace(/\s*\(\d+\/\d+\s+drivers?\)/gi, '');

  // Drop trailing detail parens e.g. "(deadhead/temporal)" after driver counts removed
  s = s.replace(/\s*\(deadhead\/[^)]*\)/gi, '');

  return s.replace(/\s+/g, ' ').trim();
}

/**
 * Returns one or more chart bucket keys for a trip reason.
 * Combined planner strings joined with " | " count toward each phase segment separately.
 * @param {string|null|undefined} raw
 * @returns {string[]}
 */
export function getUnassignedReasonChartKeys(raw) {
  if (!raw || typeof raw !== 'string') return ['Unknown'];

  const parts = raw.includes('|') ? raw.split('|') : [raw];
  const keys = parts
    .map((part) => normalizeReasonSegment(part.trim()))
    .filter(Boolean);

  return keys.length > 0 ? keys : ['Unknown'];
}

/**
 * Single normalized label (joins combined segments — prefer getUnassignedReasonChartKeys for charts).
 * @param {string|null|undefined} raw
 * @returns {string}
 */
export function normalizeUnassignedReason(raw) {
  const keys = getUnassignedReasonChartKeys(raw);
  if (keys.length === 0) return 'Unknown';
  if (keys.length === 1) return keys[0];
  return keys.join(' | ');
}
